/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_FebInputs */

const en_better_studio_month_feb = /** @type {(inputs: Better_Studio_Month_FebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feb`)
};

/**
* | output |
* | --- |
* | "Feb" |
*
* @param {Better_Studio_Month_FebInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_feb = /** @type {((inputs?: Better_Studio_Month_FebInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_FebInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_feb(inputs)
});